import * as Yup from 'yup'
const fastSellProductConvertToMarketProductFormSchema = Yup.object().shape({
  product_category: Yup.object().required('Pilihan kategory wajib.')
    .test(
      'category-not-leaf',
      'tolong pilih sub-kategori',
      (category) => ( category.is_leaf )
    ),
  price_offer: Yup.number().min(2000000, 'Harga minimal Rp 2,000,000').required('Wajib diisi.')
})

export default fastSellProductConvertToMarketProductFormSchema
